import { useEffect, useState } from 'react';

type VisualViewportBox = {
  height: number;
  offsetTop: number;
};

export const useVisualViewportBox = (enabled: boolean) => {
  const [box, setBox] = useState<VisualViewportBox | null>(null);

  useEffect(() => {
    const viewport = window.visualViewport;

    if (!enabled || !viewport) {
      return;
    }

    const update = () =>
      setBox({ height: viewport.height, offsetTop: viewport.offsetTop });

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);

    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, [enabled]);

  return enabled ? box : null;
};
